(() => {
    const wrapper = document.querySelector(
        '[data-desktop-navigation-menu-wrapper]',
    );

    const swoosh = wrapper.querySelector(
        '[data-desktop-navigation-menu-swoosh]',
    );
    const links = wrapper.querySelectorAll('a');

    links.forEach(link => {
        link.addEventListener('mouseover', () => {
            const wrapperBCR = wrapper.getBoundingClientRect();
            const linkBCR = link.getBoundingClientRect();

            swoosh.style.left = `${linkBCR.left - wrapperBCR.left}px`;
            swoosh.style.width = `calc(${linkBCR.width}px - .25em)`;
            swoosh.style.opacity = 0.85;
        });
    });
})();
